import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { FundRequestStatus, FundsFilters, FundsRequestDataForm, MassiveStatusForm } from '../../models/Fund';
import { getFetchDefaultHeaders, fetchDefaultHeaders } from '../shared/vars';
import { blob } from 'stream/consumers';

const useFundsRequestService = () => {

    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingStoreFundsRequest, setFetchingStoreFundsRequest] = useState(false);
    const [fetchingCreateFundsRequest, setFetchingCreateFundsRequest] = useState(false);
    const [fetchingCalculateFundsRequest, setFetchingCalculateFundsRequest] = useState(false);
    const [fetchingAllFundsRequest, setFetchingAllFundsRequest] = useState(false);
    const [fetchingDeleteFundsRequest, setFetchingDeleteFundsRequest] = useState(false);
    const [fetchingChangeFundsRequestStatus, setFetchingChangeFundsRequestStatus] = useState(false);
    const [fetchingEditFundsRequest, setFetchingEditFundsRequest] = useState(false);
    const [fetchingUpdateFundsRequest, setFetchingUpdateFundsRequest] = useState(false);
    const [fetchingFundRequestStatusesRows, setFetchingFundRequestStatusesRows] = useState(false);
    const [fetchingMassiveDeleteFundRequestRows, setFetchingMassiveDeleteFundRequestRows] = useState(false);
    const [fetchingConfirmFundsRequestsByWorker, setFetchingConfirmFundsRequestsByWorker] = useState(false);
    const [fetchingConfirmFundsRequestTotalsByWorker, setFetchingConfirmFundsRequestTotalsByWorker] = useState(false);
    const [fetchingGetTxtFundsRequest, setFetchingGetTxtFundsRequest] = useState(false);
    const [fetchingGetWorkerSocietyFundsRequest, setFetchingGetWorkerSocietyFundsRequest] = useState(false);


    
    const getAllFundsRequests = (
        filter: FundsFilters,
        events: ServiceEvents = {}
    ) => {
        const queryString = Object.entries(filter)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.FUNDS_REQUEST.ALL}?${queryString}`;

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingAllFundsRequest
        });
    };

    const storeFundsRequest = (fundRequest: FundsRequestDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.FUNDS_REQUEST.STORE_FUNDS_REQUEST,
            body: fundRequest,
            setFetching: setFetchingStoreFundsRequest
        });
    };

    const createFundsRequest = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.FUNDS_REQUEST.CREATE_FUNDS_REQUEST,
            setFetching: setFetchingCreateFundsRequest
        });
    };

    const calculateFundsRequest = (
        start_date: string | Date, 
        end_date: string | Date, 
        worker_id: number, 
        request_reason: string, 
        events: ServiceEvents = {}
    ) => {
        doGet({
            ...events,
            url: EndPoints.FUNDS_REQUEST.CALCULATE_FUNDS_REQUEST.replace(':start_date', start_date.toString())
                .replace(':end_date', end_date.toString())
                .replace(':worker_id', worker_id.toString())
                .replace(':request_reason', request_reason),
            setFetching: setFetchingCalculateFundsRequest
        });
    };

    const deleteFundsRequest = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.FUNDS_REQUEST.DELETE_FUNDS_REQUEST.replace(':id', id.toString()),
            setFetching: setFetchingDeleteFundsRequest
        });
    };

    const changeFundsRequestStatus = (id: number, status: FundRequestStatus, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.FUNDS_REQUEST.CHANGE_FUNDS_REQUEST_STATUS.replace(':id', id.toString()),
            body: status,
            setFetching: setFetchingChangeFundsRequestStatus
        });
    };

    const editFundsRequest = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.FUNDS_REQUEST.EDIT_FUNDS_REQUEST.replace(':id', id.toString()),
            setFetching: setFetchingEditFundsRequest
        });
    };

    const updateFundsRequest = (
        id: number,
        fundsRequest: FundsRequestDataForm,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.FUNDS_REQUEST.UPDATE_FUNDS_REQUEST.replace(':id', id.toString()),
            body: fundsRequest,
            setFetching: setFetchingUpdateFundsRequest
        });
    };

    const changeFundRequestStatusesRows = (
        massiveStatusForm: MassiveStatusForm,
        events: ServiceEvents = {}
    ) => {
        return doPut({
            ...events,
            url: EndPoints.FUNDS_REQUEST.CHANGE_FUNDS_REQUEST_STATUSES_ROWS,
            body: massiveStatusForm,
            requestType: 'json',
            headers: {
                'Content-Type': 'application/json',
                ...getFetchDefaultHeaders()
            },
            setFetching: setFetchingFundRequestStatusesRows
        });
    };

    const massiveDeleteFundRequestRows = (        
        massiveStatusForm: MassiveStatusForm,
        events: ServiceEvents = {}
    ) => {
        return doDelete({
            ...events,
            url: EndPoints.FUNDS_REQUEST.MASIVE_DELETE_FUNDS_REQUEST_ROWS,
            body: massiveStatusForm,
            requestType: 'json',
            headers: {
                'Content-Type': 'application/json',
                ...getFetchDefaultHeaders()
            },
            setFetching: setFetchingMassiveDeleteFundRequestRows
        });
    };

    
    const getConfirmFundsRequestsByWorker = (
        filter: FundsFilters,
        events: ServiceEvents = {}
    ) => {
        const queryString = Object.entries(filter)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.FUNDS_REQUEST.CONFIRMED_BY_WORKER}?${queryString}`;

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingConfirmFundsRequestsByWorker
        });
    };

    const getConfirmFundsRequestTotalsByWorker = (
        filter: FundsFilters,
        events: ServiceEvents = {}
    ) => {
        const queryString = Object.entries(filter)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.FUNDS_REQUEST.CONFIRMED_TOTAL_BY_WORKER}?${queryString}`;

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingConfirmFundsRequestTotalsByWorker
        });
    };

        
    const getTxtAllFundsRequests = (
        filter: FundsFilters,
        events: ServiceEvents = {}
    ) => {
        const queryString = Object.entries(filter)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.FUNDS_REQUEST.GET_TXT}?${queryString}`;

        fetch(url, { headers: { ...fetchDefaultHeaders }})
            .then((res) => {
                res.blob()
                    .then((blob) => {
                        const a = document.createElement('a');
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = 'reporte.txt';
                        a.click();
                        window.URL.revokeObjectURL(url);
                    })
            })
    };

    const getWorkerSocieties = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.FUNDS_REQUEST.GET_WORKER_SOCIETY.replace(':society_id', id.toString()),
            setFetching: setFetchingGetWorkerSocietyFundsRequest
        });
    };


    return {
        fetchingStoreFundsRequest,
        fetchingCreateFundsRequest,
        fetchingAllFundsRequest,
        fetchingDeleteFundsRequest,
        fetchingCalculateFundsRequest,
        fetchingChangeFundsRequestStatus,
        fetchingEditFundsRequest,
        fetchingUpdateFundsRequest,
        fetchingFundRequestStatusesRows, 
        fetchingMassiveDeleteFundRequestRows,
        fetchingConfirmFundsRequestsByWorker,
        fetchingConfirmFundsRequestTotalsByWorker,
        fetchingGetTxtFundsRequest,
        fetchingGetWorkerSocietyFundsRequest,
        getAllFundsRequests,
        storeFundsRequest,
        createFundsRequest,
        deleteFundsRequest,
        calculateFundsRequest,
        changeFundsRequestStatus,
        editFundsRequest,
        updateFundsRequest,
        changeFundRequestStatusesRows,
        massiveDeleteFundRequestRows,
        getConfirmFundsRequestsByWorker,
        getConfirmFundsRequestTotalsByWorker,
        getTxtAllFundsRequests,
        getWorkerSocieties
    };
};

export default useFundsRequestService;